import { ref as x, watch as g } from "vue";
function C(e) {
  let r = 0;
  for (const i of e)
    r++;
  return r;
}
function T(e) {
  return e === "" || e == null;
}
function b(e) {
  const r = x(null);
  function i() {
    const { value: t } = e;
    if (!(t != null && t.focus)) {
      u();
      return;
    }
    const { selectionStart: l, selectionEnd: n, value: o } = t;
    if (l == null || n == null) {
      u();
      return;
    }
    r.value = {
      start: l,
      end: n,
      beforeText: o.slice(0, l),
      afterText: o.slice(n)
    };
  }
  function d() {
    var t;
    const { value: l } = r, { value: n } = e;
    if (!l || !n)
      return;
    const { value: o } = n, { start: f, beforeText: c, afterText: a } = l;
    let s = o.length;
    if (o.endsWith(a))
      s = o.length - a.length;
    else if (o.startsWith(c))
      s = c.length;
    else {
      const h = c[f - 1], v = o.indexOf(h, f - 1);
      v !== -1 && (s = v + 1);
    }
    (t = n.setSelectionRange) === null || t === void 0 || t.call(n, s, s);
  }
  function u() {
    r.value = null;
  }
  return g(e, u), {
    recordCursor: i,
    restoreCursor: d
  };
}
export {
  T as isEmptyInputValue,
  C as len,
  b as useCursor
};
